import { useEffect } from "react";
import { useState } from "react";
import { FormattedMessage } from "react-intl";
import styled, { keyframes } from "styled-components";
import useGlobal from "../../../hooks/useGlobal";

export default function SyncProcess() {
  const { stepNum, stepStaus } = useGlobal();

  const [num, setNum] = useState(0);
  useEffect(() => {
    const n = ((stepNum || 0) / 1000) * 100;
    setNum(n > 100 ? 100 : n);
  }, [stepNum]);
  return (
    <Wrapper>
      {/* <div >
        <FormattedMessage id="正在计步"></FormattedMessage>
      </div> */}
      <div className="process">
        <div className="active" style={{ width: num  + "%" }}>
          <div className="shop">
            <img src="image/icons/icon6.png" width={40} alt="step" />
            <div className="step">
              {/* <img src="image/icons/icon20.png" width={5} alt="step" /> */}
              <div className={!!stepStaus ? "num ani" : "num"}>
                <FormattedMessage
                  id="components.nav.step"
                  values={{ step: stepNum }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Wrapper>
  );
}
const breath = keyframes`
        0%{
            transform:scale(1);
            opacity: 0.1;
        }
        25%{
            transform:scale(1.05);
            opacity: 1;
        }
        50%{
            transform:scale(1.05);
            opacity: 0.1;
        }
        75%{
            transform:scale(1.05);
            opacity: 1;
        }
       `;
const Wrapper = styled.div`

  position: relative;
  text-align: center;
  font-weight: 400;
  font-size: 1.2rem;
  line-height: 1.2rem;
  margin-top: 1.6rem;
  margin-bottom: 7.0rem;
  color: #000000;
  padding: .5rem 3.0rem 0;
  .ani {
    animation: ${breath} 4s ease-in-out infinite alternate;
  }
  .process {
    height: .6rem;
    background: #dcdcdc;
    border-radius: 1.0rem;
    margin-top: 2.4rem;
  }
  .active {
    width: 0%;
    transition: width 1s;
    background: #59cdc3;
    height: 100%;
    border-radius: 1.0rem;
    position: relative;
  }

  .shop {
    position: absolute;
    top: -2.0rem;
    right: -1.8rem;
    z-index: 1;
    /* background-color: #f9f9f9; */
    img {
      width: 4.0rem;
      height: 4.0rem;
    }
  }
  .step {
    position: relative;
    z-index: 9;
    img {
      width: 1.3rem;
      height: auto;
      margin-top: -4px;
    }
    .num {
      border: 1px solid #000000;
      border-radius: .5rem;
      font-weight: 500;
      font-size: 1.2rem;
      line-height: 1.2rem;
      color: #000000;
      padding: .5rem .7rem;
      position: relative;
      top: -2px;
      white-space: nowrap;
      &:after {
        content: "";
        position: absolute;
        width: .5rem;
        height: .5rem;
        border: 1px solid #000;
        top: -4px;
        border-left: none;
        border-bottom: none;
        left: 50%;
        background: #fff;
        transform: translateX(-50%) rotate(316deg);
      }
    }
  }
`;
